/**
 * Traduz os motivos de geração de termos
 * @param reason Motivo em formato de chave
 * @returns Motivo traduzido para exibição
 */
export function translateReason(reason: string): string {
  const reasonMap: Record<string, string> = {
    TROCA_GERENTE: "Troca de Gerente",
    FERIAS: "Férias",
    ATESTADO: "Atestado",
    DESLIGAMENTO: "Desligamento",
    LICENCA_MATERNIDADE: "Licença Maternidade",
    PEDIDO_DEMISSAO: "Pedido de Demissão",
    OUTROS: "Outros",
  };

  return reasonMap[reason] || reason;
}

/**
 * Traduz os status dos termos
 * @param status Status em formato de chave
 * @returns Status traduzido para exibição
 */
export function translateStatus(status: string): string {
  const statusMap: Record<string, string> = {
    PENDING: "Pendente",
    APPROVED: "Aprovado",
    REJECTED: "Rejeitado",
    TERM_SIGNED: "Assinado",
    TERM_PENDING_SIGNATURE: "Assinatura Pendente",
    CANCELED: "Cancelado",
  };

  return statusMap[status] || status;
}
